import { LocalStorageKey } from 'shared/constants/localStorage'
import { lsGetItem } from 'shared/utils/local-storage'

export const FORGE_BASE = (process.env.REACT_APP_FORGE_API_URL || '').replace(
  /\/+$/,
  ''
)

export const FORGE_ORIGIN = (() => {
  try {
    return FORGE_BASE ? new URL(FORGE_BASE).origin : ''
  } catch {
    return ''
  }
})()

export const isForgeConfigured = (): boolean => Boolean(FORGE_BASE)

export const getForgeToken = (): string => {
  try {
    return lsGetItem(LocalStorageKey.USER)?.access_token || ''
  } catch {
    return ''
  }
}

export const getForgeOrgId = (): string => {
  try {
    const orgId = lsGetItem(LocalStorageKey.USER)?.organization_id
    return orgId != null ? String(orgId) : ''
  } catch {
    return ''
  }
}

// Loaded by the iframe directly, not axios, so it must be fully qualified.
// When forge is unconfigured this returns "" instead of a relative path: a
// relative path resolves against the container's own origin, the SPA server
// answers it with index.html, and the iframe boots a second container that
// renders the same artifact tiles — unbounded iframe recursion that grew a
// renderer past 12 GB before Chrome killed the tab.
export const artifactViewUrl = (publicId: string): string =>
  isForgeConfigured()
    ? `${FORGE_BASE}/api/v1/artifacts/${encodeURIComponent(publicId)}/view`
    : ''
